(function () {
  var K_DONE = 'pgh_lead_done', K_CLOSED = 'pgh_lead_closed', DAYS = 14;
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // A form posted successfully on this page load: remember it, so the popup never shows again
  var posted = /[?&]customer_posted=true/.test(location.search);
  if (posted && document.querySelector('[data-pl-ok]')) set(K_DONE, '1');

  var pop = document.getElementById('pl-dialog');
  if (!pop || typeof pop.showModal !== 'function') return;

  function open() {
    if (pop.open) return;
    pop.showModal();
    document.documentElement.classList.add('pl-lock');
  }
  function close() {
    pop.close();
  }
  pop.addEventListener('close', function () {
    document.documentElement.classList.remove('pl-lock');
    if (!get(K_DONE)) set(K_CLOSED, String(Date.now()));
  });
  pop.querySelectorAll('[data-pl-close]').forEach(function (b) { b.addEventListener('click', close); });
  pop.addEventListener('click', function (e) { if (e.target === pop) close(); });

  // Came back from the popup's own form: show the download buttons in the popup
  if (posted && location.hash === '#pgh-lead-pop') { open(); return; }

  if (get(K_DONE)) return;
  var closedAt = Number(get(K_CLOSED) || 0);
  if (closedAt && Date.now() - closedAt < DAYS * 864e5) return;

  var armed = true;
  function trigger() { if (!armed) return; armed = false; cleanup(); open(); }
  var t = setTimeout(trigger, 20000);
  // Some templates scroll an inner container, not the window: read whichever element scrolled
  function onScroll(e) {
    var el = e.target && e.target.nodeType === 1 ? e.target : document.scrollingElement;
    var h = el.scrollHeight - el.clientHeight;
    if (h > innerHeight && el.scrollTop / h > 0.5) trigger();
  }
  function onLeave(e) { if (!e.relatedTarget && e.clientY <= 0) trigger(); }
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  if (matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', onLeave);
  function cleanup() {
    clearTimeout(t);
    document.removeEventListener('scroll', onScroll, { capture: true });
    document.removeEventListener('mouseout', onLeave);
  }
})();

/* Creem checkout: every buy action goes to Creem (payments + file delivery). Map: Shopify variant id -> Creem product id */
(function () {
  var C = {"45745447338007": "prod_1o9eiIczGJY6Pz706hAIYw", "45776432889879": "prod_1o9eiIczGJY6Pz706hAIYw", "45760230129687": "prod_10ALmebRdR2m5KwprNGtqF", "45776433053719": "prod_10ALmebRdR2m5KwprNGtqF", "45760230883351": "prod_4Rlk9yv49aM6FSpvcGRXJr", "45776433086487": "prod_4Rlk9yv49aM6FSpvcGRXJr", "45760231211031": "prod_B0Xjo6ccpg3aytsBEXA2P", "45776433119255": "prod_B0Xjo6ccpg3aytsBEXA2P", "45760231702551": "prod_3yiPzjAVl6PUely6ZYz0hr", "45776433152023": "prod_3yiPzjAVl6PUely6ZYz0hr", "45760231964695": "prod_1KD3v3zhFmX8ELEHqSieYW", "45776433184791": "prod_1KD3v3zhFmX8ELEHqSieYW", "45760232390679": "prod_7Vo5UQSlZHTrnj5zsMN8E4", "45776433217559": "prod_7Vo5UQSlZHTrnj5zsMN8E4", "45760232718359": "prod_6end03rRTNqzTtMzyLS7OL", "45776433250327": "prod_6end03rRTNqzTtMzyLS7OL", "45760232816663": "prod_4ewBeVK95uJWOKJfC3MVqI", "45776433283095": "prod_4ewBeVK95uJWOKJfC3MVqI", "45760233046039": "prod_4OsRJtYXVANcR5yWIpuoFA", "45958499074071": "prod_2iTcwZmepw5bJNmfzg2YWa", "45958499106839": "prod_2iTcwZmepw5bJNmfzg2YWa", "45958500745239": "prod_74FkDyeEs5k6yrDNNSNEbX", "45958500778007": "prod_74FkDyeEs5k6yrDNNSNEbX", "45958500909079": "prod_20p3Sq95isH6CviXd1Vp6b", "45958500941847": "prod_20p3Sq95isH6CviXd1Vp6b", "45958503038999": "prod_1VoC0Y9vkPJXTLH4zx52dC", "45958503071767": "prod_1VoC0Y9vkPJXTLH4zx52dC", "45958503202839": "prod_4XMTwQs8QBISa594jX42Td", "45958503235607": "prod_4XMTwQs8QBISa594jX42Td", "45958503366679": "prod_4wWc0UGwxOIn2oHEx8ocnR", "45958503399447": "prod_4wWc0UGwxOIn2oHEx8ocnR", "45958509789207": "prod_4YgGMNDJd4U2PPtsW2TYxx", "45958509821975": "prod_4YgGMNDJd4U2PPtsW2TYxx", "45958509985815": "prod_61jFTQVNbS71913vGDAjO0", "45958510018583": "prod_61jFTQVNbS71913vGDAjO0", "45958510215191": "prod_2NbToIFc3VIFJim1Q4efRH", "45958510247959": "prod_2NbToIFc3VIFJim1Q4efRH", "45958512508951": "prod_71hAbJ8PD5QIHZoc18HsQM", "45958512541719": "prod_71hAbJ8PD5QIHZoc18HsQM"};
  var B = 'https://www.creem.io/payment/';
  function u(v) { v = String(v || ''); return C[v] ? B + C[v] : null; }
  function fromHref(h) { var m = /\/cart\/(\d+):/.exec(h || ''); return m && u(m[1]); }
  function fromForm(f) { var i = f && f.querySelector('[name="id"]'); return i && u(i.value); }
  function go(url, e) { e.preventDefault(); e.stopImmediatePropagation(); location.href = url; }
  var st = document.createElement('style');
  st.textContent = '.accelerated-checkout-block,shopify-accelerated-checkout,.shopify-payment-button{display:none!important}';
  document.head.appendChild(st);
  function fix(root) {
    (root || document).querySelectorAll('a[href*="/cart/"]').forEach(function (a) {
      var url = fromHref(a.getAttribute('href')); if (url) a.setAttribute('href', url);
    });
  }
  fix();
  document.addEventListener('DOMContentLoaded', function () { fix(); });
  new MutationObserver(function () { fix(); }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('submit', function (e) { var url = fromForm(e.target); if (url) go(url, e); }, true);
  window.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var a = t.closest('a[href*="/cart/"]');
    if (a) { var h = fromHref(a.getAttribute('href')); if (h) return go(h, e); }
    var s = t.closest('sticky-add-to-cart');
    if (s && t.closest('button')) {
      var sv = u(s.getAttribute('data-current-variant-id')) || fromForm(document.querySelector('form[data-type="add-to-cart-form"]'));
      if (sv) return go(sv, e);
    }
    var b = t.closest('button[name="add"],button[type="submit"]');
    if (b) { var fu = fromForm(b.form || b.closest('form')); if (fu) go(fu, e); }
  }, true);
})();
